import apiConfig from "@/api/apiConfig";
import {HubConnectionBuilder} from '@microsoft/signalr';

export default {
  getHubConnection(api, hub) {
    const url = `${apiConfig.baseURL}/${api}/hubs/${hub}`;
    const options = {accessTokenFactory: () => {
        return window.$cookies.get('auth');
      } }; //{skipNegotiation: true, transport: HttpTransportType.WebSockets}
    return new HubConnectionBuilder()
      .withUrl(url, options)
      .withAutomaticReconnect()
      .build();
  }
}
